import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function GlobalLegalComplianceDefaultWidget(props) {
  return (
    <DefaultWidgetTemplate
      module={props.module}
      route="user_module_globalLegalCompliance_evaluation"
    />
  );
}
